import Search, { SearchInitConfig, SearchClientConfig} from "../search";
import Utility from '../../classes/utility';
import PCSearchCustomRender from '../customRenders/pc-custom-render'
import SearchUtility from "../utilities/search-utility";
import { MenuItem } from "instantsearch.js/es/connectors/menu/connectMenu";
import { ViewFilterType } from "../search";

// Define FacetsRefinements interface for counting active filters
interface FacetsRefinements {
    [key: string]: string[];
}

class ProgramsAndCoursesSearch extends Search {
    
    constructor(clientConfig: SearchClientConfig, initConfig: SearchInitConfig) {
        super(clientConfig, initConfig);
    }

    init() {
        super.init();

        // custom search for updating filter number on mobile button
        this.customSearch = function(helper) {
            let mobileFiltersButton = document.getElementById("mobile-filters-btn");
            if (mobileFiltersButton) {
                var filtersActiveCount: number = Object.values(this.search.helper.state.disjunctiveFacetsRefinements as FacetsRefinements)
                .reduce((acc: number, curr: Array<string>) => {
                    return acc + curr.length;
                }, 0);

                // if 0 display filters if not display filters (count)
                if (filtersActiveCount > 0) {
                    mobileFiltersButton.innerHTML = `Filters (${filtersActiveCount})`;
                } else {
                    mobileFiltersButton.innerHTML = `Filters`;
                }
            }
        };
        
        // get query in URL - if set
        let query = Utility.getUrlParameter(this.initConfig.queryName);

        // trigger filters
        this.onloadGetParameters();
        this.lazyloading = true;
        // trigger search on page load query
        if (query) {
            this.search.helper.setQuery(query)
            this.search.helper.search();
        }
    }

    private onLoadSearch() {
        const searchBox = document.getElementById(this.initConfig.searchBoxId);
        if (searchBox) {
            this.init();
        }
    }

    private onLoadViewFilters() {
        // init view filters
        // search needs to be defined for the below to work
        const searchBox = document.getElementById(this.initConfig.searchBoxId);
        const DeliverylabelFn = function (item: MenuItem) {
            item.label = Utility.removeAfterHyphen(item.label);
            return item;
        };

        const AOILabelFn = (item: MenuItem): MenuItem => {
            item.label = item.label
                .replace(/([a-z])([A-Z])/g, "$1 $2")
                .split(' ')
                .map((word, idx) => 
                    idx === 0 || word.toLowerCase() !== 'and' 
                    ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                    : word.toLowerCase()
                )
                .join(' ');
            return item;
        };

        this.addViewFilter({
            elementId: "filter-aoi",
            modFn: AOILabelFn,
            filterType: ViewFilterType.RefinementList,
            cssClasses : {
                input: "form-check-input",
                item: "form-check"
            }
        });

        this.addViewFilter({
            elementId:"filter-international-students",
            filterType: ViewFilterType.RefinementList,
            cssClasses: {
                input: "form-check-input",
                item: "form-check"
            }
        });

        this.addViewFilter({
            elementId:"filter-credentials",
            filterType: ViewFilterType.RefinementList,
            cssClasses: {
                input: "form-check-input",
                item: "form-check"
            }
        });
        
        this.addViewFilter({
            filterType: ViewFilterType.Clear,
            elementId: `${this.initConfig.searchBoxId}-clear-filters`
        });

        this.addViewFilter({
            filterType: ViewFilterType.SortBy,
            elementId: `${this.initConfig.searchBoxId}-sortby`
        });

        // this.addViewFilter({
        //     elementId: "selectAOI",
        //     modFn: AOILabelFn,
        //     cssClasses : { 
        //         select: "GoAAOISearch pc-filter" 
        //     }
        // });
        // this.addViewFilter({
        //     elementId: "selectDelivery",
        //     modFn: DeliverylabelFn,
        // });
        // this.addViewFilter({
        //     elementId: "selectCredential",
        // });
        // this.addViewFilter({
        //     elementId: "selectStatus",
        // });
    }

    onloadGetParameters()
    {
        let urlSearchParams = new URLSearchParams(window.location.search);
        // force select to update value on URL parms
        /*let selectElement = function (id: string, valueToSelect: string) {
            let element = document.getElementById(id) as HTMLSelectElement;
            if (element !== null) {
                element.value = valueToSelect;
                element.dispatchEvent(new Event('change'));
            }
        }*/
        const self = this;
        if(urlSearchParams != null)
        {
            if(urlSearchParams.has("areaofinterest"))
            {
                var areaOfInterest = urlSearchParams.get('areaofinterest');
                if(areaOfInterest !== null){
                    self.filterOptions("filter-aoi", areaOfInterest);
                }
            }
            if(urlSearchParams.has("credential"))
            {
                var credential = urlSearchParams.get('credential');
                if(credential!== null){
                    self.filterOptions("filter-credentials", credential);
                }
            }
            if(urlSearchParams.has("international"))
            {
                var international = urlSearchParams.get('international');
                if(credential!== null){
                    self.filterOptions("filter-international-students", international);
                }
            }
        }
    }

    filterOptions(elementID, selectedField) {
        let filterDiv = document.getElementById(elementID) as HTMLDivElement;
        if(filterDiv){
            var si = setInterval(() => {
                let inputFilters : NodeListOf<HTMLInputElement> = filterDiv.querySelectorAll('input');
                clearInterval(si);
                inputFilters.forEach(item => {
                    if(selectedField.toLowerCase() == item.value.toLowerCase()){
                        item.click();
                        item.checked = true;
                        item.dispatchEvent(new Event('click'));
                    }
                });

            }, 1000);
        }
    }

    private onLoadViewUpdates() {
        // programs and courses navigation tabs
        const tabsContainer = document.querySelector('.pc-tabs-container');
        if(tabsContainer != null){
            let pcTabs: NodeListOf<Element> = tabsContainer.querySelectorAll('.pc-tabs-container .nav-link');
            pcTabs.forEach(tab => {
                tab.addEventListener('click', function() {
                    const activeTab: HTMLElement = tabsContainer.querySelector('.nav-link.active') as HTMLElement;
                    if(activeTab){
                        activeTab.classList.remove('active');
                    }
                    this.classList.toggle('active');
                })
            });
        }
    }

    override onLoad(facets: Array<any>) {
        //this.onLoadFacets(facets);
        this.onLoadViewFilters();
        this.onLoadSearch();
        this.onLoadViewUpdates();
    }
}
export default ProgramsAndCoursesSearch;